
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 0H9C7.9 0 7 .9 7 2v9a2 2 0 002 2h13c1.11 0 2-.89 2-2V2a2 2 0 00-2-2zm0 11H9V3.67L15.5 7 22 3.67V11zm-6.5-5.69L9 2h13l-6.5 3.31zM5 11c0 .17.03.33.05.5H1c-.552 0-1-.45-1-1s.448-1 1-1h4V11zM3 1.5h2.05c-.02.17-.05.33-.05.5v1.5H3c-.55 0-1-.45-1-1s.45-1 1-1zm-2 5c0-.55.45-1 1-1h3v2H2c-.55 0-1-.45-1-1z","fill":"#165A9F"}})])
          )
        }
      }
    